module.exports = {
  PREDES_TRANSACTIONS_RELEASE_REQUEST: 'PREDES_TRANSACTIONS_RELEASE_REQUEST',
  PREDES_TRANSACTIONS_RELEASE_SUCCESS: 'PREDES_TRANSACTIONS_RELEASE_SUCCESS',
  PREDES_TRANSACTIONS_RELEASE_FAILURE: 'PREDES_TRANSACTIONS_RELEASE_FAILURE',
  PREDES_TRANSACTIONS_BULK_RELEASE_REQUEST: 'PREDES_TRANSACTIONS_BULK_RELEASE_REQUEST',
  PREDES_TRANSACTIONS_BULK_RELEASE_SUCCESS: 'PREDES_TRANSACTIONS_BULK_RELEASE_SUCCESS',
  PREDES_TRANSACTIONS_BULK_RELEASE_FAILURE: 'PREDES_TRANSACTIONS_BULK_RELEASE_FAILURE',
};
